import React from "react"
import Link from "gatsby-link"
import styled from "styled-components"
import { Divider, Flex, Box, Subhead } from "rebass"
import {
  faTwitter,
  faFacebookF,
  faInstagram,
} from "@fortawesome/fontawesome-free-brands"

import MaxWidth from "../MaxWidth"
import CircleIcon from "../CircleIcon"
import logo from "../../images/yklogonew_glow.png"

let FooterLink = styled(Link)`
  color: #999;
  font-weight: normal !important;
  font-size: 14px;
  font-family: inherit;
`

const FooterBox = styled(Box)``

FooterBox.defaultProps = {
  pr: [2, 4, 4, 2],
  width: [1, 1 / 2, 1 / 2, 1 / 4],
}

const Footer = () => (
  <Flex flexDirection="column" color="#999" bg="#222" py={4}>
    <MaxWidth
      pt={4}
      pb={4}
      flexWrap="wrap"
      justifyContent="space-between"
      flexDirection={["column", "column", "row", "row"]}
    >
      <Flex flex="1" alignItems="flex-end" mb={0} pb={[4, 4, 0, 0]}>
        <Flex flexDirection="column" flex="1" alignItems="flex-start">
          <Link to="/">
            <img alt="" src={logo} style={{ height: "100px", width: "auto" }} />
          </Link>
          <p style={{ marginBottom: 0 }}>© 2019 Yellowknife Wireless.</p>
        </Flex>
      </Flex>

      <Flex flexDirection="column" pt={[4, 4, 0, 0]}>
        <Subhead color="#eee" fontSize={1} mb={2}>
          CONTACT US
        </Subhead>
        <div>Phone: (541) 385 - 0111</div>
        <div>Email: Frontdesk@ykwc.com</div>
        <div>
          Location: 136 NW Greenwood Ave,
          <br />Bend, OR 97703
        </div>
        <div>Open M-F 8am-5pm</div>
        <Flex pt={3}>
          <a href="https://twitter.com/ykwireless">
            <CircleIcon
              mr={2}
              bg="#fff"
              borderColor="#fff"
              size="lg"
              icon={faTwitter}
              color="#000"
              height="3.0rem"
              width="3.0rem"
            />
          </a>
          <a href="https://www.instagram.com/chiefsnuff/">
            <CircleIcon
              mr={2}
              bg="#fff"
              borderColor="#fff"
              size="lg"
              prefix="fab"
              icon={faInstagram}
              color="#000"
              height="3.0rem"
              width="3.0rem"
            />
          </a>
          <a href="https://www.facebook.com/pages/Yellowknife-Wireless-Company/805621339566246">
            <CircleIcon
              mr={2}
              bg="#fff"
              borderColor="#fff"
              size="lg"
              icon={faFacebookF}
              color="#000"
              height="3.0rem"
              width="3.0rem"
            />
          </a>
        </Flex>
      </Flex>
    </MaxWidth>
  </Flex>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js